enum MediaQueryName {
  Tablet = 'Tablet',
  LaptopSmall = 'LaptopSmall',
  LaptopLarge = 'LaptopLarge',
  Desktop = 'Desktop',
  Default = 'Default'
}

export default MediaQueryName
